<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
        <small>(仅供查看方便，不列入需求内，勿在此页面提任何需求)</small>
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="user_id"
                         label="用户ID"></el-table-column>
        <el-table-column label="活动当天免费参与数">
          <template slot-scope="scope">
            <span>{{data.take_part_fee_day_limit}}</span>
          </template>
        </el-table-column>
        <el-table-column label="活动当天最大参与数">
          <template slot-scope="scope">
            <span>{{data.take_part_day_limit}}</span>
          </template>
        </el-table-column>
        <el-table-column label="当天参与数">
          <template slot-scope="scope">
            <span>{{scope.row.take_part_day_limit}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        fairid: this.$route.params.fairid,
      },
      data: {
        take_part_fee_day_limit: 0,
        take_part_day_limit: 0,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.page('getFair', this.search.fairid).then(({data}) => {
      this.data.take_part_day_limit = data.take_part_day_limit
      this.data.take_part_fee_day_limit = data.fair_setting.take_part_fee_day_limit
    })
  },
  methods: {
    ...Vuex.mapActions(['getFairUserLimit', 'getFair']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getFairUserLimit', params)
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/fair/pages/FairRewardUserLimitTable.vue